<div class="requirement-reassignment-view">
  <div class="back-button" (click)="onBackClick()">
    <mat-icon>arrow_back</mat-icon>
    <span>Back to Reassignment Types</span>
  </div>

  <div class="requirement-reassignment-content">
    <!-- Step 1: Select Requirement -->
    <div class="step-container">
      <h2 class="step-title">Step 1: Select Requirement</h2>
      <div class="dropdown-container">
        <label class="dropdown-label">Select requirement to assign:</label>
        <select
          class="requirement-dropdown"
          [(ngModel)]="selectedRequirement"
          (change)="onRequirementSelected(selectedRequirement)"
        >
          <option value="">Select requirement…</option>
          <option
            *ngFor="let requirement of requirements"
            [ngValue]="requirement"
          >
            {{ requirement.requirement }}
          </option>
        </select>
      </div>
    </div>

    <!-- Step 2: Select Staff -->
    <div class="step-container" *ngIf="selectedRequirement">
      <h2 class="step-title">Step 2: Select Staff</h2>
      <div class="staff-list-container" *ngIf="userList.length > 0">
        <div class="list-header">
          <h3>Select Staff Members</h3>
          <div class="select-all-container">
            <mat-checkbox
              [checked]="selectAllUsers"
              (change)="toggleSelectAllUsers()"
            >
              Select All ({{ filteredUserList.length }})
            </mat-checkbox>
          </div>
        </div>

        <div class="search-container">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            placeholder="Search staff by name or email..."
            [(ngModel)]="userSearchText"
            (input)="onUserSearchChange(userSearchText)"
            class="search-input"
          />
        </div>

        <div class="list-content">
          <div *ngFor="let user of filteredUserList" class="list-item">
            <mat-checkbox
              [checked]="isUserSelected(user)"
              (change)="toggleUserSelection(user)"
            >
            </mat-checkbox>
            <span class="item-text"
              >{{ user.firstName }} {{ user.lastName }}</span
            >
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="userList.length === 0">
        <div class="empty-state-content">
          <mat-icon class="empty-icon">group</mat-icon>
          <h3>No staff found</h3>
        </div>
      </div>
    </div>

    <!-- Step 3: Review and Assign -->
    <div
      class="step-container"
      *ngIf="selectedUsers.length > 0 && selectedRequirement"
    >
      <h2 class="step-title">Step 3: Review and Assign</h2>

      <div class="transfer-container">
        <div class="selected-staff-list">
          <h3>Selected Staff ({{ selectedUsers.length }})</h3>
          <div class="selected-staff-items">
            <div
              *ngFor="let user of selectedUsers"
              class="selected-staff-item"
            >
              <span>{{ user.firstName }} {{ user.lastName }}</span>
              <button
                class="remove-btn"
                (click)="toggleUserSelection(user)"
                title="Remove from selection"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <div class="assignment-info">
          <h3>Assignment Details</h3>
          <div class="requirement-info">
            <strong>Requirement:</strong>
            {{ selectedRequirement.requirement }}
          </div>
          <div class="staff-count">
            <strong>Staff Count:</strong>
            {{ selectedUsers.length }} member(s)
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button
          class="assign-btn"
          (click)="assignRequirementsToUsers()"
          [disabled]="
            selectedUsers.length === 0 ||
            !selectedRequirement ||
            isProcessing
          "
        >
          <span *ngIf="!isProcessing">
            Assign "{{ selectedRequirement.requirement }}" to
            {{ selectedUsers.length }} Staff Member(s)
          </span>
          <span *ngIf="isProcessing">
            <i class="fas fa-spinner fa-spin"></i> Processing...
          </span>
        </button>
      </div>

      <!-- Progress indicator -->
      <div
        *ngIf="isProcessing"
        class="progress-indicator"
        id="progress-indicator"
      >
        <div class="progress-message">{{ progressMessage }}</div>
        <div class="progress-details">
          <span class="progress-percentage"
            >{{ Math.round(progressPercentage) }}%</span
          >
          <span *ngIf="estimatedTimeRemaining > 0" class="time-remaining">
            Estimated time remaining: {{ estimatedTimeRemaining }}s
          </span>
        </div>
        <div class="progress-bar">
          <div
            class="progress-fill"
            [style.width.%]="progressPercentage"
          ></div>
        </div>
        <div class="progress-warning">
          <mat-icon>warning</mat-icon>
          <span>Please do not navigate away during this operation</span>
        </div>
      </div>
    </div>

    <!-- Validation message -->
    <div
      class="step-container validation-message"
      *ngIf="selectedUsers.length > 0 && !selectedRequirement"
    >
      <div class="validation-content">
        <mat-icon class="validation-icon">warning</mat-icon>
        <span>Please select a requirement before assigning staff.</span>
      </div>
    </div>
  </div>
</div>

